export default __webpack_public_path__ + "static/media/i2.b2487dca.jpg";